/**
 * 第三方券商合作
 *
 * Bridge         标准类，配置进门属性
 * CommonBridge   第三方公共类，配置第三方公共属性及方法
 * thirdBridge      第三方私有类，配置第三方私有属性及方法
 *
 * 权重为：thirdBridge > CommonBridge > Bridge
 *
 * 说明：
 * 1、第三方都有的属性用isThirdParty, 第三方没有对应的bridge时、只有isThirdParty生效
 * 2、合作项目有以下几种方式：authMethod
 * 	 (1) comein_channel                 			h5页面，有登录页面。例如：中信证券
 *   (2) comein_channel 和 comein_sign  			h5页面，无登录页面，通过sign鉴权。例如：华泰证券
 *   (3) navigator.userAgent             			嵌入第三方App、无登录页面，通过与App交互鉴权。例如：招商证券
 *   (4) navigator.userAgent 或 __wxjs_environment 	嵌入第三方小程序、无登录页面，
 *   (5) channel 和 userInfo						h5页面、嵌入第三方App、小程序、无登录页面。标准的合作模式
 */
import CommonBridge from './bridge_common';
import { isApp, isWxMiniProgram, getUserInfo, removeUserInfo, getUrlParam } from '../../utils/api';
import { LOGO, THIRDPARTY } from '../../utils/const';

function Bridge() {
	this.isThirdParty = false;

	// 显示回到第三方券商列表的按钮
	this.showMenu = false;

	// 显示进门App下载
	this.showAppDownload = true;

	// App下载提示语
	this.descTxt = '音质3倍流畅，可离线下载';

	// 第三方登录页面
	this.instituteLogin = {
		// 登录方式，0：手机号，1：邮箱
		loginWay: [0, 1],
		// 邮件登录类型，0 为中信证券，其余默认为 1
		emailLoginType: 1
	};

	// 路演详情
	this.roadshow = {};

	// IR企业号
	this.flagship = {};

	// 小程序下载文件地址
	this.downloadFile = '/newPackage/download-document/download-document?url=';

	this.invoke = function (funcName, params, success, error) {
		let func = this[funcName];
		if (typeof func === 'function') {
			func(params, success, error);
		} else {
			typeof success === 'function' && success();
		}
	};

	this.invokeSync = function (funcName, ...params) {
		let func = this[funcName];
		if (typeof func === 'function') {
			return func(...params);
		} else {
			return null;
		}
	};
}

// 获取分享配置
Bridge.prototype.getShareData = function () {
	return {
		title: '进门-领先的机构投研服务平台',
		desc: '进门（股票代码：838764），领先的机构投研服务平台，平台以专业的投研分析为核心，基于首席分析师大量深度研究、上市公司调研、行业专家产业解读，聚合、精炼高质量高价值的研究成果，助力投资者投资决策。截至目前，已与海通、招商、长江、广发等30家券商研究所建立深度战略合作关系，全行业500多位首席分析师在进门APP线上路演最新研究成果。',
		link: window.location.href,
		img_url: LOGO
	};
};

// 页面跳转
Bridge.prototype.navigateTo = function (obj, replace) {
	replace ? this.$router.replace(obj) : this.$router.push(obj);
};

const mergeObject = function (to, from) {
	Object.keys(from).forEach(key => {
		if (Object.prototype.toString.call(from[key]) === '[object Object]') {
			to[key] = to[key] || {};
			mergeObject(to[key], from[key]);
		} else {
			to[key] = from[key];
		}
	});
};

const initBridge = function (bridge) {
	let files = require.context('./', false, /^(\.\/bridge_).*?(\.js)$/);
	let arr = files.keys();
	for (let index = 0; index < arr.length; index++) {
		let key = arr[index];
		let isThirdParty = files(key).isThirdParty;
		if (isThirdParty) {
			bridge.isThirdParty = isThirdParty;
			return files(key).default;
		}
	}

	return null;
};

const initOtherBridge = function (bridge) {
	const module = require('./other_ir_channel.js');
	if (module.isThirdParty) {
		bridge.isThirdParty = module.isThirdParty;
		return module.default;
	} else {
		return null;
	}
};

// 获取url上的参数
function getQueryParam(name) {
	const url = window.location.href;
	const params = new URLSearchParams(url.split('?')[1]);
	return params.get(name);
}

// 清除登录信息的操作、第三方和进门的登录信息需要互顶，第三方和第三方之间也需要互顶。
const initUserInfo = function (bridge) {
	let userInfo = getUserInfo();
	console.log("📍 ~ initUserInfo ~ getQueryParam('comein_channel'):", getQueryParam('comein_channel'));
	if (getQueryParam('comein_channel') === 'brm') {
		return;
	}
	if (bridge.comein_channel) {
		if (userInfo && userInfo.comein_channel != bridge.comein_channel) {
			removeUserInfo();
		}
	} else {
		if (userInfo && userInfo.comein_channel && userInfo.comein_channel != 'irm') {
			removeUserInfo();
		}
	}
};

/** 初始化 */
const install = Vue => {
	let bridge = new Bridge();

	// 进门App 环境下不能存在合作信息
	if (isApp) {
		Vue.prototype.$bridge = bridge;
		return;
	}

	let ThirdBridge = initBridge(bridge);

	// 如果有动态资源配置，则覆盖为其他渠道的bridge
	const channel = getUrlParam().comein_channel;
	if (window.__irstore_bridge_config && window.__irstore_bridge_config[channel]) {
		ThirdBridge = initOtherBridge(bridge);
	}

	if (bridge.isThirdParty) {
		//处理原型链
		Object.assign(Bridge.prototype, CommonBridge.prototype);
		//处理变量
		mergeObject(bridge, new CommonBridge());

		//处理原型链
		Object.assign(Bridge.prototype, ThirdBridge.prototype);
		//处理变量
		mergeObject(bridge, new ThirdBridge());
	}

	initUserInfo(bridge);

	// H5 取非客户端、非小程序、非第三方
	bridge.isH5 = !isApp && !isWxMiniProgram && !bridge.isThirdParty;

	console.log(bridge);

	Vue.prototype.$bridge = bridge;
};

export default { install };
